/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import { PulseLoader } from 'react-spinners';
import { FaUser, FaLock } from 'react-icons/fa';
import { graphql, compose } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { withAlert } from 'react-alert';
import { saveToken } from '../../utils';
import { login, recoveryPassword } from '../../queries';

import RecoveryModal from '../../components/Modal/Recovery';
import SuccessRecoveryModal from '../../components/Modal/Recovery/Success';

import BackgroundUrl from '../../assets/images/login.jpg';
import LogoUrl from '../../assets/images/logo.png';

import {
  Wrapper,
  BackgroundContent,
  Logo,
  Container,
  Register,
  Content,
  Form,
  Label,
  Input,
  Link,
  Button,
} from './styles';

class Login extends Component {
  state = {
    recoveryModal: false,
    loading: false,
    email: '',
    password: '',
    emailFocus: false,
    emailError: false,
    passwordFocus: false,
    passwordError: false,
  }

  componentDidMount = () => {
    document.getElementById('html').style.overflowY = 'hidden';
  }

  registerStore = () => {
    window.location.href = 'https://reformafacil.app/parceiro/loja/';
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    await this.validateInputs();

    const { emailError, passwordError } = this.state;

    if (!emailError && !passwordError) {
      this.setState({ loading: true, emailFocus: false, passwordFocus: false });

      const { email, password } = this.state;

      this.props
        .login({
          variables: {
            email,
            password,
          },
        })
        .then(async (res) => {
          this.setState({ loading: false });

          const { jwt } = res.data.loginPortal;

          saveToken(jwt);

          this.props.history.push('/dashboard');
        })
        .catch((err) => {
          this.setState({ loading: false });

          if (/email/i.test(err.message) || /password/i.test(err.message)) {
            this.setState({ emailError: true, passwordError: true });
            this.props.alert.error('E-mail e/ou senha incorretos');
          }
        });
    }
  }

  validateInputs = () => {
    this.setState({ emailError: false, passwordError: false });

    const { email, password } = this.state;

    const emailReg = /^[a-z0-9][a-z0-9-_.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/;
    if (!emailReg.test(email)) this.setState({ emailError: true });
    if (password.length === 0) this.setState({ passwordError: true });
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.type]: e.target.value });
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  openRecoveryModal = () => {
    this.recoveryModal.openRecoveryModal();

    this.setState({ recoveryModal: true });
  };

  closeRecoveryModal = () => {
    this.setState({ recoveryModal: false });
  };

  openSuccessRecoveryModal = () => {
    this.setState({ successRecoveryModal: true });
  };

  closeSuccessRecoveryModal = async () => {
    this.setState({ successRecoveryModal: false });
  };

  render() {
    const {
      recoveryModal,
      successRecoveryModal,
      loading,
      email,
      emailFocus,
      emailError,
      passwordError,
      passwordFocus,
    } = this.state;

    return (
      <div>
        <MetaTags>
          <title>Entrar - Portal da Loja - Reforma Fácil</title>
        </MetaTags>
        <Wrapper>
          <BackgroundContent style={{ backgroundImage: `url(${BackgroundUrl})` }}>
            <Logo src={LogoUrl} alt="Logo Reforma Fácil" title="Reforma Fácil" />
          </BackgroundContent>
          <Container>
            <Register>
              <p>Quer ser uma loja parceira?</p>
              <button type="submit" onClick={this.registerStore}>Cadastre-se</button>
            </Register>
            <Content>
              <div className="login">
                <div className="welcome">
                  <h1>Olá! Seja bem-vindo</h1>
                  <p>Gerencie sua loja com facilidade através do nosso portal</p>
                </div>
                <Form onSubmit={this.handleSubmit}>
                  <Label
                    error={emailError}
                    onFocusInput={emailFocus}
                  >
                    <FaUser className="fa fa-user" />
                    <Input
                      type="email"
                      placeholder="E-mail"
                      onChange={this.handleInputChange}
                      onFocus={() => this.onFocus('emailFocus')}
                      onBlur={() => this.onBlur('emailFocus')}
                    />
                  </Label>
                  <Label
                    error={passwordError}
                    onFocusInput={passwordFocus}
                  >
                    <FaLock className="fa fa-lock" />
                    <Input
                      type="password"
                      placeholder="Senha"
                      onChange={this.handleInputChange}
                      onFocus={() => this.onFocus('passwordFocus')}
                      onBlur={() => this.onBlur('passwordFocus')}
                    />
                    <Link onClick={this.openRecoveryModal}>Redefinir</Link>
                  </Label>
                  <Button type="submit" disabled={loading}>
                    {!loading ? (
                      'Entrar'
                    ) : (
                      <PulseLoader
                        sizeUnit="px"
                        size={7}
                        color="#FFFFFF"
                        loading={loading}
                      />
                    )}
                  </Button>
                </Form>
              </div>
            </Content>
          </Container>
        </Wrapper>
        <RecoveryModal
          ref={(ref) => { this.recoveryModal = ref; }}
          open={recoveryModal}
          success={this.openSuccessRecoveryModal}
          close={this.closeRecoveryModal}
          recoveryPassword={this.props.recoveryPassword}
        />
        <SuccessRecoveryModal
          open={successRecoveryModal}
          email={email}
          close={this.closeSuccessRecoveryModal}
        />
      </div>
    );
  }
}

export default compose(
  withAlert(),
  withRouter,
  graphql(login, { name: 'login' }),
  graphql(recoveryPassword, { name: 'recoveryPassword' }),
)(Login);
